var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Board, Cell } from "./board";
import { Command, Controller } from "./controller";
import { Storage } from "./storage";
import { Renderer } from "./renderer";
import { sleep } from "./utils";
export class Game {
    constructor(cfg) {
        this.cfg = cfg;
        this.storage = new Storage("game-state.v1", {
            cells: [
                (cells) => cells === null || cells === void 0 ? void 0 : cells.map(({ x, y, value }) => ({ x, y, value })),
                (parsed) => parsed === null || parsed === void 0 ? void 0 : parsed.map(({ x, y, value }) => new Cell({ x, y }, value)),
            ],
        });
    }
    get state() {
        const persisted = this.storage.load();
        const DEFAULT_STATE = {
            boardSize: this.cfg.boardSize,
            cells: [],
            score: 0,
            afterPartyMode: false,
        };
        if (this._state) {
            return Object.assign(Object.assign({}, DEFAULT_STATE), this._state);
        }
        if (persisted) {
            return persisted;
        }
        return DEFAULT_STATE;
    }
    setState(patch) {
        const newState = Object.assign(Object.assign({}, this.state), patch);
        this.storage.save(newState);
        this._state = newState;
    }
    bootstrap() {
        const resetButton = document.getElementById("reset-button");
        const currentScoreValue = document.getElementById("current-score-value");
        const controller = new Controller(this.cfg.boardElement);
        const renderer = new Renderer(this.cfg.boardElement, this.state.boardSize);
        const board = new Board(this.state.boardSize);
        const moveHandler = {
            [Command.UP]: () => board.move("y", -1),
            [Command.DOWN]: () => board.move("y", 1),
            [Command.LEFT]: () => board.move("x", -1),
            [Command.RIGHT]: () => board.move("x", 1),
        };
        const reset = () => {
            this.setState({ cells: [], score: 0, afterPartyMode: false });
            board.reset();
            board.spawnCells(2);
            currentScoreValue.innerHTML = String(this.state.score);
        };
        board.onCellsMerge((cell) => {
            const currentScore = this.state.score + cell.value;
            this.setState({ score: currentScore });
            currentScoreValue.innerHTML = String(currentScore);
        });
        board.onUpdate(({ cells }) => {
            renderer.render(cells);
            if (this.isGameOver(cells)) {
                return locked(() => sleep(300).then(() => {
                    alert("Game Over!");
                    reset();
                }));
            }
            if (this.isWin(cells) && !this.state.afterPartyMode) {
                return locked(() => sleep(300).then(() => {
                    const afterPartyMode = confirm("You just reached the 2048 🎉🎉🎉. Do you want to continue?");
                    if (afterPartyMode) {
                        this.setState({ afterPartyMode: true });
                        return;
                    }
                    reset();
                }));
            }
            this.setState({ cells });
        });
        resetButton.addEventListener("click", () => reset());
        controller.listenCommand((key) => {
            const move = moveHandler[key];
            const hasMoved = move();
            // spawn cell if has moved
            if (hasMoved)
                board.spawnCells(1);
        });
        if (this.state.cells.length > 0) {
            board.restore(this.state.cells);
        }
        else {
            reset();
        }
        renderer.mount();
        currentScoreValue.innerHTML = String(this.state.score);
    }
    isWin(cells) {
        const GOAL = 2048;
        return cells.some((cell) => cell.value === GOAL);
    }
    isGameOver(cells) {
        const getCoordsKey = (coords) => `${coords.x}x${coords.y}`;
        const noEmptyCells = cells.length === Math.pow(this.cfg.boardSize, 2);
        if (!noEmptyCells) {
            return false;
        }
        const cellsMap = cells.reduce((acc, cell) => ((acc[getCoordsKey(cell.coords)] = cell), acc), {});
        return cells.every((cell) => {
            const siblings = [
                cellsMap[getCoordsKey({ x: cell.x + 1, y: cell.y })],
                cellsMap[getCoordsKey({ x: cell.x - 1, y: cell.y })],
                cellsMap[getCoordsKey({ x: cell.x, y: cell.y + 1 })],
                cellsMap[getCoordsKey({ x: cell.x, y: cell.y - 1 })],
            ];
            return siblings.every((sib) => !sib || sib.value !== cell.value);
        });
    }
}
let isLocked = false;
const locked = (callback) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isLocked) {
        isLocked = true;
        const res = yield callback();
        isLocked = false;
        return res;
    }
});
